import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.purchase-orders.PurchaseOrderUiAdapter.';
  public static readonly openingPurchaseOrder = `${Id.prefix}openingPurchaseOrder`;
  public static readonly pleaseWaitWhileConstructingPurchaseOrder = `${Id.prefix}pleaseWaitWhileConstructingPurchaseOrder`;
}

export class LangPurchaseOrderUiAdapter {
  private constructor() {}
  public static openingPurchaseOrder(): string {
    return interpolate(Id.openingPurchaseOrder);
  }
  public static pleaseWaitWhileConstructingPurchaseOrder(): string {
    return interpolate(Id.pleaseWaitWhileConstructingPurchaseOrder);
  }
}

export class PurchaseOrderUiAdapterModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.openingPurchaseOrder,
      "Opening {{glossary 'purchase-order'}}",
      'Message shown while opening a purchase order'
    );
    register.add(
      Id.pleaseWaitWhileConstructingPurchaseOrder,
      "Please wait while we construct the {{glossary 'purchase-order'}}",
      'Message shown while constructing a purchase order'
    );
  }
}
